import React from 'react';
import { WidgetEmpty } from './common';

/**
 * One short paragraph written by Hamster from the same data the other
 * widgets show. Generated server side and cached per user, so a reload does
 * not cost another model call.
 */
const HamsterBriefWidget = ({ data }) => {
  if (!data.available) {
    return <WidgetEmpty>{data.reason || 'Hamster is not available right now.'}</WidgetEmpty>;
  }
  return (
    <div className="mydesk-brief">
      <p className="mydesk-brief-text">{data.text}</p>
      {data.generated_label && <span className="mydesk-brief-meta">Written {data.generated_label}</span>}
    </div>
  );
};

export default HamsterBriefWidget;
